import { useMemo } from "react";
import { useGetAreaListingData } from "./useGetAreaListingData";

export const useGetCheapestCaravanPrice = () => {
  const { data: areaListingData } = useGetAreaListingData();

  const cheapestCaravanPrice = useMemo(() => {
    let lowestPrice = Number.POSITIVE_INFINITY;

    if (!areaListingData) {
      return 0;
    }

    // Loop over each county
    for (const county in areaListingData) {
      // Loop over each area within the county
      for (const areas in areaListingData[county]) {
        // Loop over each park within the area
        for (const park in areaListingData[county][areas]) {
          // Get cheapest caravan from the park
          const parkData = Object.values(areaListingData[county][areas][park])[0];
          const parksLowestPrice = Math.min(...parkData.map((x) => x.price));
          // Set it to the lowest price if it's a new lowest
          if (parksLowestPrice < lowestPrice) {
            lowestPrice = parksLowestPrice;
          }
        }
      }
    }

    return lowestPrice;
  }, [areaListingData]);

  return { cheapestCaravanPrice };
};
